import AddCommentIcon from '@mui/icons-material/AddComment';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useEditorBubbleMenu } from 'components/EditorBubbleMenu/context';
import { ARTICLE_BODY_COPY_ID } from 'screens/editorial/asset/utility/getEditorConfigs';

export const ThreadsBubbleList = () => {
  const { editor, setBubbleView } = useEditorBubbleMenu();

  // Because richtext generic editor setup has the link bubble but also threads
  // we dont want threads to show up in places like user edit etc where
  // link is needed but not commenting threads and only show the threads on articles
  const element = editor?.options?.element;
  const isEditorialAndArticleContent =
    element && typeof element === 'object' && 'id' in element
      ? element.id === ARTICLE_BODY_COPY_ID
      : false;

  if (!editor || !isEditorialAndArticleContent) {
    return null;
  }

  return (
    <ListItem disablePadding>
      <ListItemButton
        data-testid="bubble-menu-insert-comment-btn"
        onClick={() => setBubbleView('threadsAddComment')}
      >
        <ListItemIcon>
          <AddCommentIcon />
        </ListItemIcon>
        <ListItemText primary="Add Comment" />
      </ListItemButton>
    </ListItem>
  );
};
